import axios from 'axios';

// Create Axios instance with default configuration
const apiClient = axios.create({
  baseURL: `${process.env.REACT_APP_URL_PREFIX}` ,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
});

// Request interceptor
apiClient.interceptors.request.use(
  (request) => {
    // Add authorization token if available
    const token = localStorage.getItem('authToken');
    
    if (token) {
      request.headers.Authorization = `Bearer ${token}`;
    }
    
    // You can modify request here (e.g., add other headers)
    return request;
  },
  (error) => {
    // Handle request errors
    return Promise.reject(error);
  }
);

// Response interceptor
apiClient.interceptors.response.use(
  (response) => {
    // Handle successful responses
    return response.data;
  },
  (error) => {
    // Handle response errors
    if (error.response) {
      // Server responded with a status code outside 2xx
      switch (error.response.status) {
        case 401:
          // Handle unauthorized (e.g., redirect to login)
          console.error('Unauthorized request');
          break;
        case 403:
          console.error('Forbidden access');
          break;
        case 404:
          console.error('Resource not found');
          break;
        default:
          console.error('An error occurred:', error.response.data);
      }
    } else if (error.request) {
      // No response received
      console.error('No response received from server');
    } else {
      // Error setting up the request
      console.error('Request setup error:', error.message);
    }
    
    return Promise.reject(error);
  }
);

export default apiClient;